import React from 'react';
import { useSelector } from 'react-redux';
import { ControlBar } from 'components/header/control-bar';
import { Logo } from 'components/header/logo';
import {
  getContainerWideSelector,
  isVideoUploadEnabled,
  getUploadPodcastFeatureSelector,
  navigationRootChannelsSelector,
  getCustomerSelector,
} from 'common/selectors';
import { navigationSelector } from 'common/selectors/navigation';
import { integrationSelector } from 'common/selectors/integration';
import { isIframe } from 'integration/integration.utils';
import { NavigationBarDecorated } from 'components/header/navigation-bar';

export const Header = () => {
  const navigationChannels = useSelector(navigationSelector);
  const navigationRootChannels = useSelector(navigationRootChannelsSelector);
  const withVideoUpload = useSelector(isVideoUploadEnabled);
  const withPodcastUpload = useSelector(getUploadPodcastFeatureSelector);
  const containerWide = useSelector(getContainerWideSelector);
  const integration = useSelector(integrationSelector);
  const customer = useSelector(getCustomerSelector);

  if (!navigationRootChannels || navigationRootChannels.length === 0) {
    return <div />;
  }

  const showLogo = !isIframe(integration);

  return (
    <div className="ct-header">
      {showLogo && (
        <div className="ct-header__background">
          <div className={`ct-header__content${containerWide ? ' ct-header__content--wide' : ''}`}>
            <div className="ct-header__logo">
              <Logo />
            </div>
            <div className="ct-header__control-bar">
              <ControlBar />
              {customer && customer.homepageUrl && (
                <a
                  href={customer.homepageUrl}
                  className="ct-header__link external-link"
                  target="_self"
                  rel="noopener noreferrer"
                >
                  {customer.homepageUrlText}
                  {customer.homepageUrlTextBold && <strong>{customer.homepageUrlTextBold}</strong>}
                </a>
              )}
            </div>
          </div>
        </div>
      )}
      <div id="page-navigation" tabIndex={-1} className="ct-navigation-bar">
        <NavigationBarDecorated
          withUpload={withVideoUpload || withPodcastUpload}
          navigationChannels={navigationChannels}
          navigationRootChannels={navigationRootChannels}
        />
      </div>
    </div>
  );
};
